import InstantWidget from '../../../src/dashboard/InstantWidget.jsx';
import ModelStatus from '../../../src/data/ModelStatus.js';
import Utility from '../../../src/core/Utility.js';
import WidgetService from '../../../src/dashboard/WidgetService.js';

const DISPLAY_MAX = 100;

class WidgetPropertyEditController {
	constructor($scope, $element, $filter, $translate, serviceWidget, serviceWorkerLogdb, $compile, $timeout, serviceLogdb) {
		this.el = $element;
		this.scope = $scope;
		this.$compile = $compile;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$translate = $translate;
		this.serviceWorkerLogdb = serviceWorkerLogdb;
		this.serviceLogdb = serviceLogdb;
		this.step = {
			id: 'loading'
		};
		this.types = serviceWidget.getTypes();
		this.scope.$on('DashboardContainerController:getCurrentWidget', this.init.bind(this));

		this.loadPropertyEditor = this.loadPropertyEditor.bind(this);
		this.bindContext = this.bindContext.bind(this);

		this.scope.$watch('vm.isDarkMode', this.toggleDarkMode.bind(this));
		this.scope.$watch('vm.ctx.data.source.guid', (newguid, oldguid) => {
			var ctxcnt = this.el.find('*[context-container]')[0];
			if(!ctxcnt) {
				return;
			}

			if(!!newguid) {
				ctxcnt.setHaveDatasource(true);
			}
			else {
				ctxcnt.setHaveDatasource(false);
			}

		});
	}

	init(e, widget, preset) {
		this.isStreamWidget = widget.isStreamQueryWidget || false;
		this.isCustomQueryWidget = widget.isCustomQueryWidget || false;
		if(this.isStreamWidget){
			this.streamQuery = widget.model.query;
			this.isValidStreamQuery = true; // 위젯이 생성되었다는 것은 일단 valid한 쿼리였을것이라는 가정.
		}
		this.step.id = 'loading';
		this.isDarkMode = false;

		this.widget = widget;
		//added in issue2769
		this.ctx = angular.copy(widget.ctx);
		this.interval = this.ctx.interval;
		this.isSourceChanged = false;
		this.hasChange = false;
		//added in issue2769

		this.preset = preset;
		this.store = preset.store;
		this.selectedDataSource = null;
		this.isSourceLoading = false;
		this.isPropertyRendered = false;
		this.scope.$apply();
		this.preset.stopTimer();
		this.scope.$broadcast('ctxInit');
		if(!widget.model) {
			this.columnInfo = [];
			this.dataModel = [];
			this.dataModelForGrid = [];
			this.dataFields = [];

			this.stepDatasource();
			this.scope.$apply();
			return;
		}
		else {
			if(widget.model.status === ModelStatus.Destroy) {
				this.columnInfo = [];
				this.dataModel = [];
				this.dataModelForGrid = [];
				this.dataFields = [];

				this.stepDatasource();
				this.scope.$apply();
				return;
			}
		}

		var widgetType = this.types.filter((type) => {
			return type.id === this.ctx.type;
		});

		if(!!this.widget.model.parentModel) {
			this.selectedDataSource = this.widget.model.parentModel;
			this.subcommand = this.ctx.data.source.subcommand;
		}
		else {
			this.selectedDataSource = this.widget.model;
			this.subcommand = null;
		}

		var model = [];
		if(Array.isArray(this.widget.latestData)) {
			this.widget.latestData.forEach((d, i) => {
				if(i < DISPLAY_MAX) {
					model.push(d);
				}
			})
		}

		this.dataModelForGrid = model;
		this.dataModel = this.widget.latestData;

		// field order를 결정하는 dataFields 는 이름의 배열로 존재해야 합니다.
		this.dataFields = Utility.exists('ctx.data.order', this)
							? this._getFieldOrderNames(Utility.getNamespace('ctx.data.order', this)) : [];

		if(this.isStream() || this.isCustom()){
			this.columnInfo = this.widget.columns;
			this.step.id = 'context';
			this.loadPropertyEditor(widgetType[0].id);
			return;
		}
		var instance = this.serviceLogdb.create(0);
		var builtQueryString = this.buildQueryString(false);
		var q = instance.query(builtQueryString, 300);
		q.onTail((helper) => {
			this.serviceLogdb.remove(instance);

			if(this.widget.columns.length >= 0) {

				this.columnInfo = this.widget.columns;
				console.log('---------->', this.columnInfo)
				this.step.id = 'context';
				this.loadPropertyEditor(widgetType[0].id);
			}
			else {

				//model 이 아예 없는 경우가 있다.
				if(model.length === 0 && !this.isStream()) {
					// 쿼리 결과 올때까지 비활성화, 스트림 위젯일 경우에는 필요없음.

					console.log('no dataModel row');

					$(this.widget.model).one(`rows.onEdit`, e => {
						this.dataModelForGrid = e.detail.result.slice(0, 100);
						this.dataModel = e.detail.result;

						//this.getColumnType(widgetType);
						this.loadPropertyEditor(widgetType[0].id);
					});


					//this.getColumnType(widgetType);
					this.loadPropertyEditor(widgetType[0].id);
				} else if(this.dataFields.length === 0 && model.length === 1){
					this.columnInfo = [];
					this.dataModel = [];
					this.dataModelForGrid = [];
					this.dataFields = [];
					this.stepDatasource();
				} else {
					//this.getColumnType(widgetType);
					this.loadPropertyEditor(widgetType[0].id);
				}
			}
		}).failed((m) => {
			this.columnInfo = [];
			this.dataModel = [];
			this.dataModelForGrid = [];
			this.dataFields = [];
			this.serviceLogdb.remove(instance);
			this.stepDatasource();
		})
	}



	getExecutableQueryString(str) {
		if(!angular.isString(str)){
			str = '';
		}
		str = str.replace(/\n/gi, ' ').replace(/(\|)*(\s)*\$filter\$/gi, '| $filter$').replace(/(\|)*(\s)*\$drilldown\$/gi, '| $drilldown$');
	    return str.replace(/\|\s\$(drilldown|filter)\$/ig, '')
	}

	buildQueryString() {
		var queryString = this.ctx.data.query;

		if(!!this.ctx.data.source && !!this.ctx.data.source.guid && !!this.store.sources[this.ctx.data.source.guid]){
			// datasource
			var datasourceQuery = this.store.sources[this.ctx.data.source.guid].getQuery()
			if(!!queryString) {
				let filterQuery = queryString.replace(/^\s*\|/, '');
				queryString = `${datasourceQuery} | ${filterQuery}`;
			}
			else {
				// instant query
				queryString = `${datasourceQuery}`;
			}
	
		}

		queryString = this.getExecutableQueryString(queryString);

		return queryString;
	}

	queryChanged(flag){
		this.isSourceChanged = flag;
		if(!!this.isSourceChanged){
			this.hasChange = true;
		} else if(!!this.interval){
			this.hasChange = false;
		}
	}

	_getFieldOrderNames(fieldOrders) {
		let result = [];
		if(Array.isArray(fieldOrders) && fieldOrders.length) {
			result = fieldOrders.map(fieldOrder => fieldOrder.key);
		}

		return result;
	}

	getColumnType(widgetType) {
		// 데이터가 이미 다 로딩된 경우, 컨텍스트 및 데이터까지 한꺼번에 보이기
		//this.columnInfo = types;
		//this.loadPropertyEditor(widgetType[0].id);
		this.serviceWorkerLogdb.data.getColumnType(this.dataModelForGrid, (types) => {
			types = types.filter(function(t) {
				return t.key !== '$$hashKey';
			});

			this.columnInfo = types;
			if(this.step.id == 'loading'){
				this.step.id = 'context';
			} // widget 의 data가 null 일경우 항상 이 루틴을 탄다.
			this.loadPropertyEditor(widgetType[0].id);
		});
	}

	loadPropertyEditor(type) {

		this.el.find('.js-widget-property-edit').empty();
		var el = angular.element('<' + type + '-property style="display:block" ng-model="vm.ctx.data" source="vm.dataModelForGrid" types="vm.columnInfo" callback="vm.bindContext"/>');
		this.$compile(el)(this.scope);
		el.appendTo('.js-widget-property-edit');
		this.isPropertyRendered = true;
	}

	isCustom(){
		return this.isCustomQueryWidget;
	}

	bindContext() {
		if(!this.isPropertyRendered){
			return;
		}
		var ctxcnt = this.el.find('*[context-container]')[0];
		if(!ctxcnt) {
			// this.step.id = 'context';
			console.warn('------!!!!')
			return;
		}

		console.warn('bindContext')

		try {
			if(this.isCustom()){
				this.step.id = 'context';
			} else if((!this.columnInfo || this.columnInfo.length === 0) && !this.isStream()){
				this.stepDatasource();
				return;
			} else {
				ctxcnt.setColumnInfo({
					'columnInfo' :this.columnInfo,
					'fieldOrder': this.dataFields
				});
				console.warn('setColumnInfo')
			}
			
		}
		catch(e) {
			this.openPropertyErrorModal('1. setColumnInfo error',  e.stack);
			$('.dashboard-container .mdlPropertyReadonly')[0].hideDialog();
			$('.dashboard-container .mdlProperty')[0].hideDialog();
		}

		try {
			// ctxcnt.setDataModel(this.widget.ctx)
			// #2654 $scope.modelValue에 배열을 할당해 주어야 하는데, this.widget.ctx에는 데이터 목록을 가지고 있지 않음 
			// 따라서 아래와 같이 처리(AddNewWidgetController의 bindField() 참고)
			ctxcnt.setDataModel(JSON.parse( angular.toJson( this.dataModelForGrid )));
		}
		catch(e) {
			this.openPropertyErrorModal('2. setDataModel error', e.stack);
			$('.dashboard-container .mdlPropertyReadonly')[0].hideDialog();
			$('.dashboard-container .mdlProperty')[0].hideDialog();
		}

		try {
			// if(this.ctx.type != 'grid'){ // grid에서 이 루틴을 탈 시에 무한루프를 돈다. 왜인지는 모름... in issue#2769, timeout 제거시 발생한 문제.
			ctxcnt.setModel(this.ctx.data);
			// }
			// this.step.id = 'context';
		}
		catch(e) {
			this.openPropertyErrorModal('3. setModel error', e.stack);
			$('.dashboard-container .mdlPropertyReadonly')[0].hideDialog();
			$('.dashboard-container .mdlProperty')[0].hideDialog();
		}
		if(!this.scope.$$phase){
			this.scope.$digest();	
		}
		
	}

	convertColumnObjectToArray(data){
		var array = data;
		if(!Array.isArray(data)){
			array = [];
			var keys = Object.keys(data);
			keys.forEach(function(key){
				var type = undefined;
				if(data[key] === 'int' ||data[key] === 'long' || data[key] === 'short' || data[key] === 'double' || data[key] === 'float' ){
					type = 'number';
				} else if(data[key] === 'ipv4' ||data[key] === 'ipv6'){
					type = 'ip';
				} else if(data[key] === 'date'){
					type = 'datetime';
				} else {
					type = data[key];
				}
				array.push({
					key:key,
					type:type
				});
			})
		}
		return array;
	}

	onSelectSource(type, data, fieldOrder, fieldTypes) {
		console.log(type, data, fieldOrder);

		this.dataModelForGrid = data.slice(0, 100);
		this.dataModel = data;
		this.dataFields = fieldOrder;
		//added in issue2513
		this.columnInfo = this.convertColumnObjectToArray(fieldTypes);
		this.bindContext();

		this.isSourceLoading = false;

		if(!this.isPropertyRendered) {
			var widgetType = this.types.filter((type) => {
				return type.id === this.ctx.type;
			});
			this.loadPropertyEditor(widgetType[0].id);
		}
		// this.serviceWorkerLogdb.data.getColumnType(this.dataModelForGrid, types => {
		// 	this.columnInfo = types;
		// 	this.bindContext();

		// 	this.isSourceLoading = false;

		// 	if(!this.isPropertyRendered) {
		// 		var widgetType = this.types.filter((type) => {
		// 			return type.id === this.ctx.type;
		// 		});
		// 		this.loadPropertyEditor(widgetType[0].id);
		// 	}
		// });

	}

	openPropertyErrorModal(type, raw) {
		throw new TypeError(type, raw);
	}

	toggleDarkMode() {
		if(this.previewWidget) {
			let rendered = this.previewWidget.rendered,
				theme = this.isDarkMode ? 'black' : 'white';
			if(typeof rendered.setStyle === 'function') {
				rendered.setStyle(theme);
			}
		}
	}

	stepDatasource(){
		this.step.id = 'datasource';
		this.$timeout(()=>{
			this.scope.$broadcast('queryRefresh');	
		})
	}

	stepContext() {
		if(this.isDisabledToRender()) {
            notify('danger', this.$filter('translate')('$S_msg_SetPropertiesError'), true);
			return;
		}
		this.step.id = 'context';
	}

	stepPreview() {
		if(!this.dataModel || this.dataModel.length === 0 && !this.isCustomQueryWidget) {
            notify('danger', this.$filter('translate')('$S_msg_DataSourceRequired'), true);
			return;
		}

		if(this.isDisabledToRender() && !this.isCustomQueryWidget) {
            notify('danger', this.$filter('translate')('$S_msg_WidgetViewError'), true);
			return;
		}

		if(!!this.previewWidget) {
			this.previewWidget.destroy();
		}

		var ctxcnt = this.el.find('*[context-container]')[0];
		var ctx = Object.assign({}, this.ctx, { data: ctxcnt.getContext() });
		if(!ctx.data) {
            notify('danger', this.$filter('translate')('$S_msg_SetAllTheNecessaryProperties'), true);
			return;
		}

		ctx.data.source = this.ctx.data.source;
		if(!!ctx.data.source) {
			if(!!this.subcommand) {
				ctx.data.source.subcommand = this.subcommand;
			}
			else {
				delete ctx.data.source.subcommand;
			}
		}

		this.step.id = 'preview';
		this.$timeout(() => {
			this.previewWidget = new InstantWidget(ctx, this.store, {
				'isReadOnly': true,
				'elTarget': this.el.find('.js-preview')[0],
				'cache': this.dataModel,
				'theme': this.isDarkMode ? 'black' : 'white',
				'columns': this.columnInfo
			});
		})
	}

	isDisabledToRender() {
		var disabled = false;
		if(this.isCustom() || this.isStream()){
			return false;
		}
		if(!this.columnInfo || this.columnInfo.length === 0){
			disabled = true;
		}
		if(!this.selectedDataSource) {
			disabled = true;
		}
		if(!this.isPropertyRendered) {
			disabled = true;
		}
		if(this.isSourceLoading) {
			disabled = true;
		}
		return disabled;
	}
	//added in issue2712
	onIntervalChanged(interval) {
		this.interval = interval;
		if(!this.interval){
			this.hasChange = true;
		} else if(!this.isSourceChanged){
			this.hasChange = false;
		}
	}
	//
	saveChanges() {
		if(!this.isCustom() && !!this.isSourceChanged){
			if(this.isStream()){
                notify('danger', this.$filter('translate')('$S_msg_QueryAgain'), true);
			} else {
                notify('danger', this.$filter('translate')('$S_msg_QueryModified'), true);
			}
			
			return;
		}
		
		if(!this.isStream() && !this.isCustom() && !Number.isInteger(this.interval)) {
			return;
		}

		if(this.isStream() && !this.isValidStreamQuery){
            notify('danger', this.$filter('translate')('$S_msg_ModifyStreamWidgetError'), true);
			return;
		}

		var ctxcnt = this.el.find('*[context-container]')[0];
		var ctx = Object.assign({}, this.ctx, { data: ctxcnt.getContext() });
		if(!ctx.data && !this.isStream()) {	// preview가 있거나 없거나
            notify('danger', this.$filter('translate')('$S_msg_SetAllTheNecessaryProperties'), true);
			return;
		}

		//added in issue2712
		if(!!this.hasChange){
			return;
		}
		//

		if(this.isStream()){
			ctx.data.query = this.streamQuery;
		} else {
			let queyrString = angular.copy(this.ctx.data.query);
			ctx.data.query = queyrString;
		}

		ctx.data.source = this.ctx.data.source;
		ctx.data.filters = this.ctx.data.filters ? [] : undefined;
		this.widget.updateContext(ctx);
		this.preset.savePreset();
		this.close(false);

	}

	close(isCancel) {
		if(!!this.previewWidget) {
			this.previewWidget.destroy();
		}

		this.el[0].hideDialog();
		this.scope.$broadcast('WidgetPropertyEditController:onClose');
	}

	isStream(){
		return this.isStreamWidget;
	}

	isStreamable(query , isValid){
		if(!this.isStream()){
			return;
		}

		this.streamQuery = query;
		this.isValidStreamQuery = isValid;
	}
}

export default WidgetPropertyEditController;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/WidgetPropertyEditController.js